import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import declare from "dojo/_base/declare";

// Returns the parent APIKeyCredentials class for a given attribute ID
const attrToClassMap = { ClientSecret: "OAuth2Credentials", Key: "APIKeyCredentials" };

const SecretRenderer = declare(StringRen, {

	/**
	 * @override
	 * Display the non-tranferrable attributes ClientSecret and Key as dots if they are populated
	 */
	toValue(ctx: Context, h: Heading): string {
		const authNodeType = ctx.getNode()?.$Type;
		const attributeID = h.m_id;

		// Check if the heading corresponds to an attribute that exists on the current APIAuthCredentials node
		if (attrToClassMap[attributeID] == authNodeType) {
			return "\u{2022}".repeat(20);
		}

		return "";
	},
});

export = SecretRenderer;